import {
    IDataArray,
} from "./../../shared/index"

export class SurveyUserActionTypes implements IDataArray {
    public Pkid = 0;
    public Action: string;

    public GetById(): number {
        return this.Pkid;
    }
}